<template>
  <div id="app">
    <topMenu></topMenu> 
    <router-view></router-view>
    <foot></foot>
    </div>
</template>

<script>

export default {
  name: 'App',
  components: {
     topMenu: () => import('@/components/common/topMenu'),
     foot: () => import('@/components/common/foot'),
  },
}
</script>

<style lang="less" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
